import { useEffect, useRef } from 'react';
import { siteConfig } from '../config/siteConfig';

const SCRIPT_ID = 'cloudflare-turnstile-script';

const loadTurnstile = () =>
  new Promise((resolve, reject) => {
    if (window.turnstile) {
      resolve(window.turnstile);
      return;
    }

    const existing = document.getElementById(SCRIPT_ID);
    if (existing) {
      existing.addEventListener('load', () => resolve(window.turnstile), {
        once: true,
      });
      existing.addEventListener('error', reject, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src =
      'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    script.addEventListener('load', () => resolve(window.turnstile), {
      once: true,
    });
    script.addEventListener('error', reject, { once: true });
    document.head.appendChild(script);
  });

export default function TurnstileWidget({ onToken, error }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!siteConfig.turnstileSiteKey || !containerRef.current) {
      return undefined;
    }

    let active = true;
    let widgetId;
    loadTurnstile()
      .then((turnstile) => {
        if (!active || !containerRef.current) return;
        widgetId = turnstile.render(containerRef.current, {
          sitekey: siteConfig.turnstileSiteKey,
          theme: 'light',
          callback: (token) => onToken(token),
          'expired-callback': () => onToken(''),
          'error-callback': () => onToken(''),
        });
      })
      .catch(() => onToken(''));

    return () => {
      active = false;
      if (widgetId !== undefined && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    };
  }, [onToken]);

  if (!siteConfig.turnstileSiteKey) {
    return (
      <div className="turnstile-placeholder" role="status">
        Güvenlik doğrulaması canlı yayın yapılandırmasında etkinleşecek.
        {error && <span className="field-error">{error}</span>}
      </div>
    );
  }

  return (
    <div>
      <div ref={containerRef} className="turnstile-widget" />
      {error && <span className="field-error">{error}</span>}
    </div>
  );
}
